/* Lisa Kookt - mobiele collectiepagina fixes (companion bij lk-collection.js).
   - Sluit-logica van de filter-drawer (open/kruisje/buiten/veeg)
   - Geselecteerde filterwaarden onder elke filter, blijvend na re-render (idempotent)
   - Actieve-filter-chips onder de Filteren/Sorteren-knoppen i.p.v. erboven
   - Tel-tekst "X korting op Y producten" -> "X van de Y producten"
   - Drawer volledig dekkend + knoppen niet helemaal onderaan (CSS)
   - Witte "recent bekeken" zijpaneel-rand rechts weg op mobiel
   - Verticale filter-sidebar (desktop): koppen lichte achtergrond, pijltje gecentreerd,
     Sorteren rechts, teller alleen bij actief filter met correcte tekst/aantal */
(function () {
  'use strict';
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- CSS-overrides ---------- */
  function injectCSS() {
    if (document.getElementById('lk-fix-css')) return;
    var st = document.createElement('style');
    st.id = 'lk-fix-css';
    st.textContent =
      '@media (max-width:749px){' +
      '.mobile-facets{height:100vh !important;height:100dvh !important;}' +
      '.mobile-facets__inner{height:100vh !important;height:100dvh !important;max-height:none !important;}' +
      '.mobile-facets__main>.mobile-facets__footer{margin-top:14px !important;position:static !important;}' +
      '.mobile-facets__main>.lk-selected-chips{margin:2px 15px 12px !important;padding-left:0 !important;}' +
      '.side_btn_panel{display:none !important;}' +
      'html,body{overflow-x:hidden !important;}' +
      '}' +
      '@media (min-width:750px){' +
      '#main-collection-filters .facets__summary{' +
      'background:#eef1e6 !important;border:1px solid #dfe3d3 !important;border-radius:8px !important;' +
      'padding:12px 16px !important;}' +
      '#main-collection-filters .facets__summary:hover{background:#e7ebdb !important;border-color:#cfd4bf !important;}' +
      '#main-collection-filters .facets__summary>div{display:flex;align-items:center;justify-content:space-between;gap:12px;}' +
      '#main-collection-filters .facets__summary .icon-caret{position:static;flex:0 0 auto;width:12px;height:12px;margin:0;top:auto;right:auto;transform:none;}' +
      '.wbsortbar .facets-vertical-sort{flex:1 1 auto !important;width:100% !important;transform:translateY(-16px) !important;}' +
      '.facets-vertical-sort .facets-vertical-form{display:flex !important;align-items:center;width:100% !important;justify-content:space-between !important;gap:16px;}' +
      '.facets-vertical-sort .facet-filters.sorting{order:2;}' +
      '.facets-vertical-sort .product-count-vertical{order:1;margin:0;}' +
      '.facets-vertical-sort .product-count-vertical.lk-count-hidden .product-count__text{display:none;}' +
      '.wbsortbar{border:0 !important;}' +
      '.facets-vertical-sort .facet-filters__label,.facets-vertical-sort .facet-filters__label label{font-size:22px !important;font-weight:500 !important;}' +
      '.facets-vertical-sort .facet-filters__sort,.facets-vertical-sort .select__select{font-size:15px !important;padding:8px 34px 8px 14px !important;}' +
      '}' +
      '@media (min-width:990px){#ProductGridContainer{margin-top:-35px;}}';
    document.head.appendChild(st);
  }

  /* ---------- Drawer sluiten ---------- */
  function closeDrawer() {
    var w = q('.mobile-facets__wrapper');
    if (!w) return;
    var d = q('details', w);
    if (!d || !d.open) return;
    d.removeAttribute('open');
    var s = q('summary', w);
    if (s) s.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-mobiel', 'overflow-hidden-tablet', 'overflow-hidden');
    document.body.classList.remove('overflow-hidden-mobile');
  }

  document.addEventListener('click', function (e) {
    var w = q('.mobile-facets__wrapper');
    if (!w) return;
    var d = q('details', w);
    if (!d || !d.open) return;
    var inner = q('.mobile-facets__inner', w);
    var summary = q('summary', w);
    var onX = e.target.closest && e.target.closest('.lk-drawer-close');
    var outside = inner && !inner.contains(e.target) && summary && !summary.contains(e.target);
    if (onX || outside) { e.preventDefault(); e.stopPropagation(); closeDrawer(); }
  }, true);

  document.addEventListener('touchstart', function (e) {
    var w = q('.mobile-facets__wrapper'); if (!w) return;
    var d = q('details', w); if (!d || !d.open) return;
    var inner = q('.mobile-facets__inner', w);
    if (!inner || !inner.contains(e.target)) return;
    inner._lkx = e.touches[0].clientX; inner._lky = e.touches[0].clientY;
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function (e) {
    var w = q('.mobile-facets__wrapper'); if (!w) return;
    var inner = q('.mobile-facets__inner', w);
    if (!inner || inner._lkx == null) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - inner._lkx, dy = t.clientY - inner._lky;
    inner._lkx = null;
    if (dx > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) closeDrawer();
  }, { passive: true, capture: true });

  /* ---------- Tel-tekst corrigeren (mobiel) ---------- */
  function fixCount() {
    qa('.mobile-facets__count, .product-count__text, #ProductCount, #ProductCountDesktop').forEach(function (el) {
      if (/korting op/i.test(el.textContent)) {
        el.textContent = el.textContent.replace(/korting op/gi, 'van de');
      }
    });
  }

  /* ---------- Desktop verticale teller: alleen bij actief filter + juist aantal ---------- */
  function filtersActive() {
    if (qa('input[name^="filter."]:checked').length) return true;
    var priced = qa('input[name*="price"]').some(function (i) { return i.value && i.value.length; });
    return priced;
  }
  function filteredCount() {
    var mc = q('.mobile-facets__count');
    if (mc) {
      var m = mc.textContent.replace(/\./g, '').match(/\d+/);
      if (m) return parseInt(m[0], 10);
    }
    if (!q('.pagination')) return qa('#product-grid .grid__item').length;
    return null;
  }
  function syncDesktopCount() {
    var box = q('.facets-vertical-sort .product-count-vertical');
    if (!box) return;
    var txt = q('.product-count__text', box);
    if (!txt) return;
    if (!filtersActive()) { box.classList.add('lk-count-hidden'); return; }
    box.classList.remove('lk-count-hidden');
    var n = filteredCount();
    if (n == null) return;
    var msg = (n === 1) ? '1 product voldoet aan je filter(s)'
                        : (n + ' producten voldoen aan je filter(s)');
    var target = q('#ProductCountDesktop', txt) || txt;
    if (target.textContent.trim() !== msg) target.textContent = msg;
  }

  /* ---------- Geselecteerde filterwaarden onder elke filter (idempotent) ---------- */
  function renderChips() {
    var wrapper = q('.mobile-facets__wrapper');
    if (!wrapper) return;
    qa('.mobile-facets__details', wrapper).forEach(function (det) {
      var summary = q('.mobile-facets__summary', det);
      if (!summary) return;
      qa('.lk-selected-chips', det).forEach(function (el) { el.remove(); });

      var labels = [];
      qa('input[type="checkbox"]:checked, input[type="radio"]:checked', det).forEach(function (inp) {
        var lab = inp.id ? det.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]') : null;
        var txt = lab ? lab.textContent : inp.value;
        txt = (txt || '').replace(/\s+/g, ' ').trim().split('(')[0].trim();
        if (txt && labels.indexOf(txt) === -1) labels.push(txt);
      });
      var price = qa('input[name*="price"]', det);
      if (price.length >= 2 && (price[0].value || price[1].value)) {
        labels.push('€' + (price[0].value || '0') + ' - €' + (price[1].value || '…'));
      }
      var desired = labels.join('|');
      var old = det.nextElementSibling;
      if (!(old && old.classList && old.classList.contains('lk-selected-chips'))) old = null;
      var current = old ? (old.getAttribute('data-lk') || '') : '';
      if (desired === current) return;
      if (old) old.remove();
      if (labels.length) {
        var box = document.createElement('div');
        box.className = 'lk-selected-chips';
        box.setAttribute('data-lk', desired);
        labels.forEach(function (l) {
          var c = document.createElement('span');
          c.className = 'lk-chip';
          c.textContent = l;
          box.appendChild(c);
        });
        det.insertAdjacentElement('afterend', box);
      }
    });
  }

  /* ---------- Actieve-filter-chips onder de knoppen plaatsen ---------- */
  function moveActiveFacets() {
    var bar = document.getElementById('lkMobileBar');
    if (!bar) return;
    var all = qa('.active-facets-mobile');
    if (!all.length) return;
    var placed = all.filter(function (el) { return el.previousElementSibling === bar; });
    var fresh = all.filter(function (el) { return el.previousElementSibling !== bar; });
    if (fresh.length) {
      placed.forEach(function (el) { el.remove(); });
      var keep = fresh[fresh.length - 1];
      fresh.slice(0, -1).forEach(function (el) { el.remove(); });
      bar.insertAdjacentElement('afterend', keep);
    }
  }

  /* ---------- Prijs-filter als laatste zetten (mobiel + desktop, idempotent) ---------- */
  function isPriceEl(el) {
    return !!(el.querySelector && (el.querySelector('input[name*="price"]') || el.querySelector('price-range')));
  }
  function reorderFilters() {
    var dw = q('#FacetsWrapperDesktop');
    if (dw) {
      var dets = qa(':scope > details', dw);
      if (dets.length > 1) {
        var price = null;
        dets.forEach(function (d) { if (isPriceEl(d)) price = d; });
        var last = dets[dets.length - 1];
        if (price && price !== last) last.insertAdjacentElement('afterend', price);
      }
    }
    var main = q('.mobile-facets__main');
    if (main) {
      var mdets = qa(':scope > .mobile-facets__details', main);
      var mprice = null, lastFilter = null;
      mdets.forEach(function (d) {
        if (d.querySelector('.mobile-facets__sort')) return;
        if (isPriceEl(d)) mprice = d;
        lastFilter = d;
      });
      if (mprice && lastFilter && mprice !== lastFilter) {
        var chip = (mprice.nextElementSibling && mprice.nextElementSibling.classList &&
                    mprice.nextElementSibling.classList.contains('lk-selected-chips')) ? mprice.nextElementSibling : null;
        lastFilter.insertAdjacentElement('afterend', mprice);
        if (chip) mprice.insertAdjacentElement('afterend', chip);
      }
    }
  }

  /* ---------- Onbruikbare sorteeropties verwijderen ("Meest relevant") ---------- */
  function stripSorts() {
    qa('select[name="sort_by"]').forEach(function (sel) {
      qa('option', sel).forEach(function (o) {
        if (o.value === 'most-relevant') o.remove();
      });
    });
    var menu = q('#lkMobileBar .lk-sortmenu');
    if (menu) {
      qa('.lk-sortopt', menu).forEach(function (b) {
        if ((b.textContent || '').trim().toLowerCase() === 'meest relevant') b.remove();
      });
    }
  }

  /* ---------- Alles toepassen + observer (altijd verbonden, functies zijn idempotent) ---------- */
  function applyAll() { fixCount(); stripSorts(); reorderFilters(); renderChips(); moveActiveFacets(); syncDesktopCount(); }
  function observerTarget() {
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      var pw = grid.closest('.page-width');
      if (pw && pw.parentElement) return pw.parentElement;
      return grid;
    }
    var bar = document.getElementById('lkMobileBar');
    return (bar && bar.parentElement) || document.body;
  }
  function startObserver() {
    var t = null;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(applyAll, 80);
    });
    obs.observe(observerTarget(), { childList: true, subtree: true });
  }

  function init() {
    injectCSS();
    applyAll();
    startObserver();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
